import React from 'react';
import { Form } from 'react-bootstrap';
import { ActionButtons } from '../../../common/components';
import { Site } from '../sitesSlice';

interface AccountSitesSelectorProps {
  sites: Site[];
  sitesForAccount: Site[];
  onSiteChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    site: Site,
  ) => void;
  backLinkUrl: string;
  saveSelectedSites: (event: React.FormEvent) => void;
}

const AccountSitesSelector: React.FunctionComponent<
  AccountSitesSelectorProps
> = ({
  sites,
  sitesForAccount,
  onSiteChange,
  backLinkUrl,
  saveSelectedSites,
}) => {
  return (
    <>
      <div>
        {sites.map(site => (
          <Form.Group controlId={site.id} className="mb-24" key={site.id}>
            <Form.Check
              type="checkbox"
              label={site.name}
              checked={sitesForAccount.some(s => s.id === site.id)}
              onChange={event => onSiteChange(event, site)}
            />
          </Form.Group>
        ))}
      </div>
      <ActionButtons
        CancelButtonUrl={backLinkUrl}
        HandleSave={saveSelectedSites}
      />
    </>
  );
};

export default AccountSitesSelector;
